import { Injectable } from "@angular/core";
import { IRewardScore } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { RewardScoreExtended } from "../models/rewardScore-extended.model";
import { RewardScore } from "../models/rewardScore.model";
import { RewardScoreApiService } from "./api/rewardScore-api.service";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class RewardScoreService {
  constructor(
    private rewardScoreApiService: RewardScoreApiService,
    private userService: UserService,
    private translateService: TranslateService
  ) {}

  public canUpdateSync(): boolean {
    return this.userService.isAuthorizedSync(null, this.rewardScoreApiService.updateRoutes[0], "PUT");
  }

  public listRewardScoresByPatient(
    patientId: string,
    startDate: string,
    endDate: string,
    onlyInProgress: boolean
  ): Observable<RewardScore[]> {
    return this.rewardScoreApiService.listRewardScoresByPatient(patientId, startDate, endDate, onlyInProgress).pipe(
      map((values) => {
        return values.map((v) => new RewardScore(v, this.translateService));
      })
    );
  }

  public listRewardScoresByService(
    serviceId: string,
    startDate: string,
    endDate: string,
    onlyInProgress: boolean,
    services?: string[],
    monitoringServicesIds?: string[]
  ): Observable<RewardScoreExtended[]> {
    return this.rewardScoreApiService
      .listRewardScoresByService(serviceId, startDate, endDate, onlyInProgress, services, monitoringServicesIds)
      .pipe(
        map((values) => {
          return values.map((v) => new RewardScoreExtended(v, this.translateService));
        })
      );
  }

  public updateRewardScore(rewardScore: IRewardScore): Observable<IRewardScore> {
    return this.rewardScoreApiService.updateRewardScore(rewardScore);
  }
}
